import React, { useContext, useState } from "react";
import { Input, Button, List, Container, Header, Dropdown, Form } from "semantic-ui-react";
import { fsfn_getFeed, fsfn_getSchedule } from "global/functions/fbFetchFunctions";
import Wrapper from "global/wrappers/Wrapper";
import WrapperVertCols from "global/wrappers/WrapperVertCols";
import { RssContext } from "global/cnr/contexts/RssContext";
import { ParentContext } from "global/cnr/contexts/ParentContext";
import _ from 'lodash'

const RssSearch = () => {

  const parentContext = useContext(ParentContext);
  const { settings, fn_cls } = parentContext ?? {}
  const { getFeed } = fn_cls ?? {}
  const { homeSettings } = settings ?? {}
  const { global: homeSettings_global } = homeSettings ?? {}
  const { rssFeeds: rssFeeds_home } = homeSettings_global ?? {}

  // RSS Context
  const { rss_state } = useContext(RssContext) ?? {}
  const { mediaFeeds, mediaFeedMessage } = rss_state ?? {}

  const [selectedFeed, setSelectedFeed] = useState({});
  const [url, setUrl] = useState('');
  const [titleSearch, setTitleSearch] = useState('');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const extractUniqueTeams = (events) => {
    return _.chain(events)
      .map("name") // get the `name` values
      .flatMap(name => name.split(" at ")) // split into [Team1, Team2]
      .map(team => team.trim()) // clean up whitespace
      .uniq() // ensure uniqueness
      .value(); // return array
  };


  const handleSearch = async () => {
    if (!url) return;
    setLoading(true);
    try {
      // const weekCount = 18
      //  const weeks = _.range(1, weekCount + 1);
      //  console.log('weeks', weeks)
      // const xxx = await fsfn_getSchedule(url, weekCount, true)
      // const { result } = xxx ?? {}
      // console.log('result', result)
      // const { allEvents } = result ?? {}
      // console.log('allEvents', allEvents)
      // const allEvents_g = _.groupBy(allEvents, 'week.number')
      // console.log('allEvents_g', allEvents_g)

      const { result, success } = await getFeed(url)
      if (success) {
        console.log('result', result)
        const { items, events } = result ?? {}
        if (items) {
          let _items = items
          if (titleSearch) {
            _items = _items.filter((item) =>
              item.title.toLowerCase().includes(titleSearch.toLowerCase())
            )
          };
          setItems(_items);
        } else if (events) {
          const uniqueTeams = extractUniqueTeams(events)
          const teams = _.fromPairs(
            uniqueTeams.map((team) => [team, { name: team, schedule: [] }])
          );
          // Step 3: Fill in schedule for each team
          _.forEach(events, (event) => {
            const { name } = event;
            const [away, home] = name.split(" at ").map((t) => t.trim());
            _.forEach(uniqueTeams, (team) => {
              if (team === home || team === away) {
                teams[team].schedule.push({
                  week: event.week?.number,
                  name: event.name,
                  startDate: event.date,
                  home: {
                    name: home
                  },
                  away: {
                    name: away
                  }
                });
              }
            });
          });
          console.log('teams', teams)
        }

      } else {
        setItems([])
      }

      // const feed = await parser.parseURL(url);
      // let filtered = feed.items;
      // if (titleSearch) {
      //   filtered = filtered.filter((item) =>
      //     item.title.toLowerCase().includes(titleSearch.toLowerCase())
      //   );
      // }
    } catch (err) {
      console.error("Error parsing RSS feed:", err);
      setItems([]);
    }
    setLoading(false);
  };

  const handleChange_selectedFeed = (e, data) => {
    if (rssFeeds_home[data.value]) {
      setSelectedFeed(data.value)
      setUrl(rssFeeds_home[data.value].baseUrl)
    }
  }

  const dd = () => {
    if (rssFeeds_home) {
      const optsList = []
      _.map(rssFeeds_home, (feed, feedKey) => {
        optsList.push({
          key: feedKey, text: _.startCase(feedKey), value: feedKey
        })
      })
      return <Form.Select placeholder='Rss Feeds'
        text={selectedFeed ? selectedFeed : 'Rss Feeds'}
        label={'Existing Rss Feeds'}
        search
        selection
        options={_.sortBy(optsList, 'text')} onChange={handleChange_selectedFeed} />
    }
  }


  const search = () => <div><Form>

    {dd()}

    <Form.Input
      fluid
      label={'Rss Url'}
      placeholder="Enter RSS feed URL..."
      value={url}
      onChange={(e) => setUrl(e.target.value)}
      style={{ marginBottom: "1em" }}
    />

    <Form.Input
      fluid
      label={'Title'}
      placeholder="Search by title..."
      value={titleSearch}
      onChange={(e) => setTitleSearch(e.target.value)}
      style={{ marginBottom: "1em" }}
    />

    <Button
      primary
      loading={loading}
      onClick={handleSearch}
      style={{ marginBottom: "2em" }}
    >
      Search
    </Button>

  </Form></div>

  const list = () => <List divided relaxed>
    {_.map(items, (item, idx) => (
      <List.Item key={idx}>
        <List.Content>
          <List.Header as="a" href={item.link} target="_blank">
            {item.title}
          </List.Header>
          <List.Description>{item.pubDate}</List.Description>
        </List.Content>
      </List.Item>
    ))}
  </List>

  const wrapper_list = () => <Wrapper
    header={<Header as="h2">{'List: ' + url}</Header>}
    content={list()}
    css={{ container: 'app-dark-mode' }}
  ></Wrapper>

  const youtub_list = () => <Wrapper
    Header={<Header as="h2">You Tube</Header>}
    content={ifr()}
    css={{ container: 'app-dark-mode' }}
  ></Wrapper>

  const ifr = () => <div className="iframe-container"><iframe
    width="100%"
    height="500"
    src="https://www.youtube.com/embed/videoseries?list=UUKHIxkfiTl1ipOzzqzw3R5Q"
    // src='https://youtube.com/@fxcathletics?si=BWt0-egBTi5TLOyP'
    frameborder="0"
    allowfullscreen>
  </iframe></div>

  const content = () => <WrapperVertCols mvc={'2'}>
    {search()}
    {wrapper_list()}
    {/* {youtub_list()} */}
  </WrapperVertCols>

  return (
    <Wrapper
      Header={<Header as="h2">RSS Feed Search</Header>}
      content={content()}
      css={{ container: 'app-dark-mode' }}
    ></Wrapper>
  );
};

export default RssSearch;
